export default function Content({children,content}){
    return  <div className={content}>{children}</div>
}